// --
import React from "react";
import {Loader} from './../';
import KontaktOvereniApi from "./../api/gen/subjekty/KontaktOvereniApi";
import * as TypKontaktu from "./../api/gen/proxioapi/TypKontaktu";

/**
 * Komponenta zobrazující informace o datových schránkách pro subjekt, který má pouze id ověření.
 */
export default class SubjektOvereniDsInfo extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            dsList: null
        };

        this.componentIsUnmounting = false;
    }

    componentWillUnmount() {
        this.componentIsUnmounting = true;
    }

    componentDidMount() {
        this.fetchDs(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.overeniId !== nextProps.overeniId) {
            this.fetchDs(nextProps);
        }
    }

    fetchDs = (props) => {
        const {overeniId} = props;

        KontaktOvereniApi.getSubjektKontakty(overeniId, [TypKontaktu.DS])
            .then(list => {
                if (!this.componentIsUnmounting) {
                    this.setState({dsList: list});
                }
            });
    };

    render() {
        const {dsList} = this.state;

        if (dsList === null) {
            return <Loader/>
        } else {
            return <span>{dsList.length > 0 ? dsList.map(ds => ds.kontakt).join(", ") : "-"}</span>
        }
    }
}
